import { appMessages as messages } from '../../../../messages'
import { PROFILE_KEY } from '../../constants'
import createValidationElementUtil from '../../../../modules/redux/utils/create-validation-element'
import { differenceInYearsDateUtil } from 'packages/src'

const MIN_AGE = 10
const MAX_AGE = 70

function birthdayProfileValidatorUtil (value) {
  if (differenceInYearsDateUtil(
    new Date(),
    new Date(value),
    'years'
  ) < MIN_AGE) {
    return createValidationElementUtil(PROFILE_KEY.BIRTHDAY, messages.minimum, {
      key: PROFILE_KEY.BIRTHDAY,
      min: MIN_AGE
    })
  }
  if (differenceInYearsDateUtil(
    new Date(),
    new Date(value),
    'years'
  ) > MAX_AGE) {
    return createValidationElementUtil(PROFILE_KEY.BIRTHDAY, messages.maximum, {
      key: PROFILE_KEY.BIRTHDAY,
      max: MAX_AGE
    })
  }
  return true
}

export default birthdayProfileValidatorUtil
